// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2mW2U","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2NoUQ"};